import React, { useState } from 'react'
import { Button, Col, Row, Tabs } from 'antd';
import './beps-forms.style.scss';
// import { DatosPersonales } from './Forms/datos-personales.view';
// import { Localidad } from './Forms/localidad.view';
// import { SisbenEducativo } from './Forms/sisben-educativo.view';
import { DocumentosBeps } from './Forms/documetosbeps.view';
import { useBepsFormN } from '../../../../../hooks/useBepsFormN';
import { DatosPersonales } from './Forms/datospersonales.view';
import { Localidad } from './Forms/localidadN.view';
import { SisbenEducativo } from './Forms/sisbeneducativo.view';
const { TabPane } = Tabs;


export const BepsForms = ({ }) => {


    
   
    
    const { 
        formBeps, 
        setFormBeps,
        openDatePickerExpedicion,
        setOpenDatePickerExpedicion,
        obtenerFechaDatePickerExpedicion,
        openDatePickerNacimiento,
        setOpenDatePickerNacimiento,
        obtenerFechaDatePickerNacimiento,
        guardarFormulario,
        handleSearchDocument,
        tab,
        nextTab,
        prevTab,
        actualizarFormulario,
        documentosBeps,
        setdocumentosBeps
    } = useBepsFormN();
   

    return (
        <div className='container-fluid2'>
        <div className="row mt-4 mb-4">
            <div className="col-12 mt-4 mb-4">
                <p className="font-size-18px font-family-Montserrat-Regular">
                    <span className="font-family-Montserrat-Bold">!GENIAL! Estás a punto de inscribirte en formulario BEPS.</span> Por favor completa el formulario de inscripción.
                    Recuerda diligenciar los campos obligatorios.
                </p>
            </div>
            <div className="col-12">
                <Tabs activeKey={tab.toString()} >
                    <TabPane tab="Datos personales" key="1">
                        <DatosPersonales 
                            formBeps={formBeps}
                            setFormBeps={setFormBeps}
                            openDatePickerExpedicion={openDatePickerExpedicion}
                            setOpenDatePickerExpedicion={setOpenDatePickerExpedicion}
                            obtenerFechaDatePickerExpedicion={obtenerFechaDatePickerExpedicion}
                            openDatePickerNacimiento={openDatePickerNacimiento}
                            setOpenDatePickerNacimiento={setOpenDatePickerNacimiento}
                            obtenerFechaDatePickerNacimiento={obtenerFechaDatePickerNacimiento}
                            guardarFormulario={guardarFormulario}
                            handleSearchDocument={handleSearchDocument}
                            tab={tab}
                            nextTab={nextTab}
                        />
                    </TabPane>
                    <TabPane tab="Localidad" key="2">
                        <Localidad 
                            formBeps={formBeps}
                            setFormBeps={setFormBeps}
                            guardarFormulario={guardarFormulario}
                            tab={tab}
                            nextTab={nextTab}
                            prevTab={prevTab}
                            actualizarFormulario={actualizarFormulario}
                        />
                    </TabPane>
                    <TabPane tab="Sisbén y nivel educativo" key="3">
                        <SisbenEducativo 
                            formBeps={formBeps}
                            setFormBeps={setFormBeps}
                            tab={tab}
                            nextTab={nextTab}
                            prevTab={prevTab}
                            actualizarFormulario={actualizarFormulario}
                        />
                    </TabPane>
                    <TabPane tab="Documentos" key="4">
                        <DocumentosBeps 
                            formBeps={formBeps}
                            prevTab={prevTab} 
                            documentosBeps={documentosBeps}
                            setdocumentosBeps={setdocumentosBeps}
                        />
                        
                    </TabPane>
                </Tabs>
            </div>
        </div>
        </div>
    )
}

